import { useTranslation } from "react-i18next";
import { useLocation } from "../../../../hooks/useRoutes";
import { usePictureSets } from "../../../../hooks/usePictureSets";
import React, { useMemo, useState } from "react";
import useTemplateList from "../../../hooks/useTemplateList";
import useGoogleFonts from "../../../../../hooks/useGoogleFonts";
import { templateFontList } from "../../../Components/EditTemplateProduct/common";
import { getAllUrlParams } from "../../../../../lib/common";
import useTemplateFilters from "../../../hooks/useTemplateFilters";
import useFilteredTemplateList from "../../../hooks/useFilteredTemplateList";
import SubHeader from "../../../Components/SubHeader";
import FiltersDialog from "../../../../Components/Template/FiltersDialog";
import TypeOptions from "./TypeOptions";
import ListTemplatesPage from "./ListTemplatesPage";
import I18n from "../../../../../i18n";

export const CalendarWrapper = ({ type, category }) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { currentPictureSet } = usePictureSets();
  const options = useMemo(() => {
    return {
      pictureSet: currentPictureSet,
      // Not really used except for getting the template list to reload
      language: i18n.language,
    };
  }, [currentPictureSet, I18n.language]);

  const [templateList, loadingTemplates] = useTemplateList(
    type,
    category,
    options,
  );
  const { loaded: fontsLoaded } = useGoogleFonts(templateFontList);

  // Get params as an object:
  const params = useMemo(() => {
    // Hack to trigger a scroll event (For templates to show)
    window.scrollTo(window.scrollX, window.scrollY - 1);
    window.scrollTo(window.scrollX, window.scrollY + 1);
    return getAllUrlParams(location.search);
  }, [location]);

  const filterOptions = useMemo(() => {
    return {
      filters: ["formats", "pages"],
      predef: params,
    };
  }, [params]);

  const [filters, toggleFilterOption] = useTemplateFilters(
    templateList,
    filterOptions,
  );

  const filteredTemplates = useFilteredTemplateList(templateList, filters);
  const [filtersOpen, setFiltersOpen] = useState(false);

  return (
    <>
      <SubHeader title={t("Calendars")} subtitle={t("Choose template")} />
      <TypeOptions
        type={type}
        setFiltersOpen={setFiltersOpen}
        filters={filters}
        toggleFilterOption={toggleFilterOption}
      />
      <ListTemplatesPage
        loading={loadingTemplates || !fontsLoaded}
        type={type}
        category={category}
        templates={filteredTemplates}
        canViewWithOwnPictures={false}
        separateFromBackground={false}
      />
      {filtersOpen && (
        <FiltersDialog
          filters={filters}
          toggleFilterOption={toggleFilterOption}
          templates={templateList.templates}
          filteredTemplates={filteredTemplates}
          onClose={() => setFiltersOpen(false)}
          onOpen={() => setFiltersOpen(true)}
        />
      )}
    </>
  );
};
